module.exports = __webpack_public_path__ + "img/2.892be7c6.png";